import get from 'lodash.get';

const getCalendlyDifmPromoOnboardingUrl = (rootState) =>
  get(rootState, 'config.common.calendly.difm_promo_onboarding_url', '');

export default getCalendlyDifmPromoOnboardingUrl;
